export default __webpack_public_path__ + "static/media/logo.c938129e.png";